import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { Navbar, Footer, CookieConsentApp } from './components';
import { NoPage, About } from './pages';
import {
  Bundesliga, 
  Epl, 
  LaLiga, 
  SerieA, 
  Ligue1, 
  PrimeiraLiga, 
  Eredivisie, 
  BrasileiroSerieA,
  Mls,
  Spl,
  Csl,
  //LeagueTables 
} from './pages';


import './App.css';



const App = () => {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Epl />} />
            <Route path="/bundes-liga" element={<Bundesliga />} />
            <Route path="/la-liga" element={<LaLiga />} />
            <Route path="/serie-a" element={<SerieA />} />
            <Route path="/ligue-1" element={<Ligue1 />} />
            <Route path="/primeira-liga" element={<PrimeiraLiga/>} />
            <Route path="/eredivisie" element={<Eredivisie />} />
            <Route path="/brasileiro-serie-a" element={<BrasileiroSerieA />} />
            <Route path="/mls" element={<Mls />} />
            <Route path="/spl" element={<Spl />} />
            <Route path="/csl" element={<Csl />} />
            <Route path="/about-us" element={<About />} />
            {/*<Route path="/league-tables" element={<LeagueTables />} />*/}
            <Route path="*" element={<NoPage />} />
          </Routes>
        </main>
        <CookieConsentApp />
        <Footer />
      </div>
    </Router>
  );
};

export default App;